<template>
  <div>
    <div id="menu-frame" class="search-box" v-if="!$root.$data.embedded">
      <button
        class="btn lhs"
        :class="{active: isListsEnabled}"
        @click="toggleFrame()"
        :title="$t('buttons.poisAndStreets')"
      >
        <img src="../assets/icons/menu.png" alt="" />
      </button>
      <img class="line-icon left" src="../assets/icons/line.png" alt="" />
      <form action="/" @submit.prevent>
        <!-- <input type="text" :placeholder="$t('searchPlaceholder')" v-debounce:500ms="submit" v-model="searchTerm" /> -->
         <input
          type="text"
          :placeholder="animatedPlaceholder"
          v-debounce:500ms="submit"
          v-model="searchTerm"
          @focus="pauseMarquee = true; marqueeIdx = 0; animatedPlaceholder = basePlaceholder"
          @blur="pauseMarquee = false"
        />
      </form>
      <button class="close-button" :class="{active: !!searchTerm}" @click="clearSearch()">
        <img src="../assets/icons/close1.png" alt="" />
      </button>

      <!-- <button class="btn rhs" @click="openDirectionFrame()" :title="$t('buttons.routing')">
        <i class="material-icons-round">directions</i>
      </button> -->
      <!-- <img class="line-icon right" src="../assets/icons/line.png" alt="" /> -->
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import {basemap} from "@/services/map/basemap";


export default {
  data() {
    return {
      searchTerm: null,
      activeRouteFrame: false,

      basePlaceholder: this.$t('searchPlaceholder'), // 2–4 spații la final pt. pauză
      animatedPlaceholder: '',
      marqueeIdx: 0,
      marqueeTimer: null,
      pauseMarquee: false,
    };
  },
  computed: {
    isListsEnabled: function () {
      return this.$route.path.indexOf("lists") >= 0;
    },
  },
  watch: {
    '$i18n.locale'() {
      this.basePlaceholder = this.$t('searchPlaceholder');
      this.marqueeIdx = 0;
      this.animatedPlaceholder = this.basePlaceholder;
    },},


  created() {
    this.searchTerm = this.$route.query["q"];
  },
  mounted() {
    this.animatedPlaceholder = this.basePlaceholder;
    this.startMarquee();
  },
  beforeDestroy() {
    this.stopMarquee();
  },
  activated() {
    this.startMarquee();
  },
  deactivated() {
    this.stopMarquee();
  },
  methods: {
    startMarquee() {
      if (this.marqueeTimer) return;

      this.marqueeTimer = setInterval(() => {
        if (this.pauseMarquee) return;

        const t = this.basePlaceholder;
        if (this.marqueeIdx >= t.length - 1) {
          this.marqueeIdx = 0;
          this.animatedPlaceholder = t; 
          return;
        }

        this.marqueeIdx += 1;
        const i = this.marqueeIdx;
        this.animatedPlaceholder = t.slice(i) + t.slice(0, i);
      }, 200); // viteza (ms)
    },
    stopMarquee() {
      if (this.marqueeTimer) {
        clearInterval(this.marqueeTimer);
        this.marqueeTimer = null;
      }
    },
    async toggleFrame() {
      if (this.isListsEnabled) {
        // this.clearMaps();   
        await this.$router.push({name: "default", query: this.$route.query});
      } else {
        await this.$router.push({name: "pois", query: this.$route.query});
      }
    },
    async submit() {
      await this.search(this.searchTerm);
    },

    async search(term) {
      if ((!term || !term.trim()) && this.$route.name === "search") {
        await this.$router.push({name: "default", query: this.$route.query});
        return;
      }

      const view = basemap.map.getView();
      const center = view.getCenter();
      const serialized = center[0] + "," + center[1] + "," + view.getZoom();

      await this.$router.push({
        name: "search",
        query: {
          ...this.$route.query,
          q: term,
          page: 0,
          location: serialized,
        },
      });
    },

    async clearSearch() {
      this.searchTerm = "";
      this.$root.$emit("clearAll3D"); 
      this.$root.$emit("reset3DToHome");
      if (this.$route.name === "search") {
        await this.$router.push({name: "default", query: this.$route.query});
      }
    
    },
    async openDirectionFrame() {
      await this.$router.push({name: "directions", query: this.$route.query});
    },
  },
};
</script>
